import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirpodLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAirpodLeft"><Path d="M9 3C10.6355 3 12.0878 3.78503 13 4.99902V11.001C12.0878 12.215 10.6355 13 9 13C8.65756 13 8.32308 12.966 8 12.9004V21H4V8C4 5.23858 6.23858 3 9 3Z" fill="currentColor"/><Path d="M17 19H20V21H15V13H17V19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAirpodLeft;
